import React from "react";

const getHeroHeight = (width, imageMeta) => {
  const fallbackRatio = 375 / 220;
  const ratio =
    imageMeta?.ratio ||
    (imageMeta?.width && imageMeta?.height ? imageMeta.width / imageMeta.height : null) ||
    fallbackRatio;
  const safeRatio = ratio > 0 ? ratio : fallbackRatio;
  const height = Math.round(width / safeRatio);
  return Math.max(160, Math.min(640, height));
};

const CanvasFrameStandard = ({ imageSrc, imageMeta, canvasElRef, CARD_WIDTH, CANVAS_HEIGHT }) => {
  const heroHeight = getHeroHeight(CARD_WIDTH, imageMeta);
  return (
    <div style={{ width: CARD_WIDTH, background: "#fff", borderRadius: 12, overflow: "hidden", border: "1px solid #ddd" }}>
      
      {/* Hero 圖片區：依照原圖比例自動調整高度 */}
      <div style={{ width: "100%", background: "#f4f4f4", height: heroHeight, overflow: "hidden" }}>
        {imageSrc ? (
          <img 
            src={imageSrc} 
            style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} 
            alt="Banner" 
          />
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "#aaa", fontSize: 13 }}>
            從左側上傳圖片
          </div>
        )}
      </div>

      {/* 2. Canvas 區 (自適應高度) */}
      <div style={{ position: "relative", background: "#fff", minHeight: 100 }}>
        <canvas ref={canvasElRef} />
      </div>
    </div>
  );
};

export default CanvasFrameStandard;